<template>
  <div class="py-4 px-6 bg-destructive text-destructive-foreground text-sm">
    Allposit is currently experiencing service disruptions due to an ongoing <a
      href="https://health.aws.amazon.com/health/status"
      target="_blank"
      class="underline text-destructive-foreground decoration-destructive-foreground/25 underline-offset-2 hover:decoration-destructive-foreground/75 cursor-pointer"
    >AWS outage</a>.
  </div>
</template>
